import Lottie from 'lottie-react';

import specialists from '../jsons/Face_Talking_Interested.json';

const FaceTalkingInterested = props => {
  return <Lottie animationData={specialists} {...props} />;
};

export default FaceTalkingInterested;
